var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChartGrowth = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32999 10V9M10.33 10V7M14.33 10V5M6.32999 18L10.33 14L14.33 18M1.32999 1H19.33M2.32999 1H18.33V13C18.33 13.5523 17.8823 14 17.33 14H3.32999C2.7777 14 2.32999 13.5523 2.32999 13V1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChartGrowth, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chart-growth.28942f20.svg";
export { ForwardRef as ReactComponent };